export class CloudPrincipalInputAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "iamArn",
            "baseName": "iamArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipalInputAws.attributeTypeMap;
    }
    constructor() {
    }
}
